module.exports = __webpack_public_path__ + "static/flags/JQ-749930e8bc43a8426c285cd1d4d8c20f.gif";